import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import React, {useRef} from "react";
import {ConfirmCodeForm} from "./ConfirmCodeForm";
import {CloseMobile, NewModal, NewModalContainer} from "../../../../components/ui/Content";
import {useOnClickOutside} from "../../../../hooks/useClickOutside";
import {setChangeDataModal} from "../api/slice";
import {ChangeDataModalInit} from "../../../../interface/Passport/Account/frontend";
import {EnterEmailForm} from "./EnterEmailForm";
import {ChangeSuccess} from "../ChangePhone/ChangeSuccess";
import {Close} from "../../../../icon/Icon";
import { setChangeDataForChangeNull, setChangeSuccessFalse } from "../UserInfo/slice";

let modalEl: HTMLDivElement;

export const ChangeEmailModal = () => {

    const dispatch = useAppDispatch()
    const {changeDataModal} = useAppSelector(state => state.account)
    const {dataForChange, success} = changeDataModal
    const ref = useRef(modalEl);

    const closeModal = () => {
        dispatch(setChangeDataModal(ChangeDataModalInit))
        dispatch(setChangeSuccessFalse())
        dispatch(setChangeDataForChangeNull())
    }
    useOnClickOutside(ref, () => closeModal())

    const Content = () => {
        if (success) {
            return <ChangeSuccess/>
        }
        if (dataForChange) {
            return <ConfirmCodeForm/>
        }
        return <EnterEmailForm/>
    }

    return <NewModal>
        <CloseMobile onClick={closeModal}>
            <Close/>
        </CloseMobile>
        <NewModalContainer ref={ref}>
            <Content/>
        </NewModalContainer>
    </NewModal>
}
